import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { isEmpty, isUndefined } from 'lodash';

/**
 * SaveCode
 *
 * Saves a single code with the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const SaveCode = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theMutationKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      data: {},
      headers: {
        'x-api-endpoint': '/code-lists/categories',
      },
      method: 'POST',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    if (!isUndefined(thePayload?.data?.categoryCode) && !isEmpty(thePayload?.data?.categoryCode)) {
      requestArgs.headers['x-api-endpoint'] += `/${thePayload?.data?.categoryCode}/code`;

      if (thePayload?.mode === 'edit' && !isUndefined(thePayload?.id) && !isEmpty(thePayload?.id)) {
        requestArgs.method = 'PUT';
        requestArgs.headers['x-api-endpoint'] += `/${thePayload?.id}`;
      }
    }

    requestArgs.data = { ...thePayload?.data };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error('src/entities/Code/api/requests/mutations/SaveCode.js -> SaveCode()', false, error);

    throw error;
  }
};
